var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content content-fixed"},[_c('div',{staticClass:"container"},[_vm._v(" sdf ")])])
}]

export { render, staticRenderFns }